import ability from './services/Ability';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import settings from '../src/settings/index.js'
import vuetify from './plugins/vuetify';
import vueMaskSettings from './plugins/vueMask';
import VueResizeText from 'vue-resize-text';

import VuetifyConfirm from 'vuetify-confirm';
import CKEditor from 'ckeditor4-vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { abilitiesPlugin } from '@casl/vue';
import { subject } from '@casl/ability';
import VueMask from 'v-mask';
import msal from 'vue-msal';
import VueGtag from "vue-gtag";

import ApiService from './services/ApiService';
import Common from './services/Common';

import DocumentService from './services/DocumentService';

import CTextField from './components/common/CTextField.vue';
import CSelect from './components/common/CSelect.vue';
import CAutocomplete from './components/common/CAutocomplete.vue';
import '@mdi/font/css/materialdesignicons.css'

// import PreventTouch from './preventTouch.js';

Vue.config.productionTip = false

// Register the directive globally
// Vue.directive('prevent-touch', PreventTouch);

Vue.prototype.$api = ApiService
Vue.prototype.$common = Common
Vue.prototype.$able = (action, subType, sub) => {
  return ability.can(action, subject(subType, sub))
}
Vue.prototype.$document = DocumentService;

Vue.use(CKEditor)

Vue.use(abilitiesPlugin, ability, { useGlobalProperties: true });
Vue.use(Toast, { timeout: 5000, position: "bottom-right", maxToasts: 10, newestOnTop: true, 
  filterBeforeCreate: (toast, toasts) => {
  if (toasts.filter(
    t => t.type === toast.type
  ).length !== 0) {
    // Returning false discards the toast
    return false;
  }
  // You can modify the toast if you want
  return toast;
} })
Vue.use(VuetifyConfirm, { vuetify, title: 'Are you sure?', icon: 'mdi-help-circle' });
Vue.use(VueResizeText);
Vue.use(VueMask, vueMaskSettings);
Vue.use(msal, {
  auth: {
    clientId: settings.clientId,// '81c6f792-834e-44c1-a1ad-2badbd5442af',
    tenantId: settings.tenantId,// '5df2193a-613c-40a6-b3e3-3d5fa26c5e11',
    redirectUri: settings.baseUrl + 'sso-aad'
  },
  cache: {
    cacheLocation: 'localStorage'
  }
});
Vue.use(VueGtag, {
  config: { 
    //id: "G-5WZPB69PM2", 
    id: "G-87XSG8P0JK",
    // params: {
    //   user_id: 1653
    // } 
  }
});

Vue.component('c-text-field', CTextField);
Vue.component('c-select', CSelect);
Vue.component('c-autocomplete', CAutocomplete);

new Vue({
  router,
  store,
  vuetify,
  // vueMask,
  render: h => h(App)
}).$mount('#app')